var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconConfirmDdgreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .greencircle {\n        fill: #2eb4a9;\n        stroke: #2eb4a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.1px;\n      }\n\n      .tick_x0020_white {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "greencircle",
    x: 5.3,
    y: 5.3,
    width: 39.5,
    height: 39.5,
    rx: 19.7,
    ry: 19.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tick_x0020_white",
    d: "M21,37.4l-8.4-7.7c-.8-.8-.9-2-.1-2.9l1.7-1.9c.8-.8,2-.9,2.9-.1l4.5,4.1,10.6-16c.6-.9,1.9-1.2,2.8-.5l2.1,1.4c.9.6,1.2,1.9.5,2.8l-13.6,20.4c-.7,1-2.1,1.2-3,.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconConfirmDdgreen);
export default __webpack_public_path__ + "static/media/cloud_icon_confirm_ddgreen.fe3f25d23aeb9a26f42789475c17afae.svg";
export { ForwardRef as ReactComponent };